(function () {
  'use strict';

  var BUTTON_IDS = {
    'ebook-button':       'ebook',
    // Uncomment to track the other retailer buttons too:
    // 'large-print-button': 'large_print',
    // 'stream-audio-button': 'audiobook'
  };

  var SEND_TIMEOUT_MS = 350;   // max wait before we navigate anyway
  var recentlySent = {};       // guards against double-firing

  /* ---------- read the currently selected variant ---------- */

  function getVariants() {
    var host = document.querySelector('variant-selects, variant-radios');
    if (!host) return [];
    var json = host.querySelector('script[type="application/json"]');
    if (!json) return [];
    try { return JSON.parse(json.textContent) || []; } catch (e) { return []; }
  }

  function getSelectedVariant() {
    var variants = getVariants();
    if (!variants.length) return null;

    // 1. ?variant= in the URL is the most reliable signal
    var idParam = new URLSearchParams(window.location.search).get('variant');
    if (idParam) {
      var byId = variants.filter(function (v) { return String(v.id) === String(idParam); })[0];
      if (byId) return byId;
    }

    // 2. fall back to the checked radio / selected option
    var host = document.querySelector('variant-selects, variant-radios');
    var chosen = null;
    if (host) {
      var radio = host.querySelector('input[type="radio"]:checked');
      if (radio) chosen = radio.value;
      if (!chosen) {
        var sel = host.querySelector('select');
        if (sel) chosen = sel.value;
      }
    }
    if (chosen) {
      var byOpt = variants.filter(function (v) {
        return (v.option1 || '').trim() === String(chosen).trim();
      })[0];
      if (byOpt) return byOpt;
    }

    // 3. last resort
    return variants[0];
  }

  function getHandle() {
    var info = document.querySelector('product-info, [data-url]');
    var url = (info && info.dataset && info.dataset.url) || window.location.pathname;
    var m = String(url).match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function getCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';
  }

  /* ---------- build and send the event ---------- */

  function buildPayload(format) {
    var v = getSelectedVariant();
    var handle = getHandle();
    var title = (document.querySelector('h1') || {}).innerText || '';

    return {
      content_name: v ? v.name : title.trim(),
      content_category: format,
      content_ids: v ? [String(v.id)] : [],
      content_type: 'product',
      product_handle: handle,
      value: v ? (v.price / 100) : 0,   // Shopify stores cents
      currency: getCurrency()
    };
  }

  /**
   * Fires the Lead event. Returns a Promise that resolves once the event
   * has had time to leave the browser (or immediately if fbq is absent).
   */
  function sendEbookLead(format) {
    format = format || 'ebook';

    // don't double-fire on rapid repeat clicks
    var now = Date.now();
    if (recentlySent[format] && now - recentlySent[format] < 1500) {
      return Promise.resolve();
    }
    recentlySent[format] = now;

    if (typeof window.fbq !== 'function') return Promise.resolve();

    var payload = buildPayload(format);
    var eventID = 'ebook-lead-' + now + '-' + Math.random().toString(36).slice(2, 10);

    try {
      window.fbq('track', 'Lead', payload, { eventID: eventID });
    } catch (e) {
      return Promise.resolve();
    }

    // give the beacon a moment to actually go out before we navigate
    return new Promise(function (resolve) {
      setTimeout(resolve, SEND_TIMEOUT_MS);
    });
  }

  window.sendEbookLead = sendEbookLead;

  /* ---------- standalone mode ----------
     Delegated listener, capture phase, bound to document so it survives
     Dawn re-rendering the product-info section on variant change.
     Only active if you set window.META_EBOOK_AUTOBIND = true before load. */

  if (window.META_EBOOK_AUTOBIND) {
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('button, a');
      if (!btn || !btn.id || !BUTTON_IDS[btn.id]) return;
      sendEbookLead(BUTTON_IDS[btn.id]);
      // note: does NOT delay navigation — see USAGE option A for that
    }, true);
  }
})();